import fieldMixin from '@phoenix/mixins/fieldMixin';

export default {
  mixins: [fieldMixin],

  inject: {
    formType: {
      default: null,
    },
  },

  computed: {
    fieldClasses() {
      return [
        'input', // Change to input
        this.fieldClass,
        {
          'input--error': this.isInvalid,
          'w-1/2': this.halfWidth,
        },
      ];
    },
  },

  methods: {
    pushFieldDataTracking() {
      if (!this.formType) return;

      window.tracking.pushEvent(window.tracking.getFieldTrackingEvent(this.field.name, this.formType));
    },
  },
};
